import enUsTranslations from 'lang/en-US.json';
import { createContext } from 'react';
import { ResolvedIntlConfig } from 'react-intl';

export const DEFAULT_LOCALE = 'en-US';

export const DEFAULT_MESSAGES = enUsTranslations;

export type Messages = ResolvedIntlConfig['messages'];

interface TranslationContextInterface {
  locale: string;
  messages: Messages;
}

export const TranslationContext = createContext<TranslationContextInterface>({
  locale: DEFAULT_LOCALE,
  messages: DEFAULT_MESSAGES,
});
